import React, { useContext, useEffect, useState, useRef } from "react";
import Navbar from "./Navbar";
import { AppContext } from "../context";

import {
  imageUpload,
  addImageToList,
  userLogs,
  patLogs,
  initializeLocation,
  setVmgFlowType,
  setVmgUrl,
  setAuthorization,
  setCustomHiibVmg,
  gethiibMssg,
  setResizing,
  imageFeedbackLambda,
  getInspectionID,
  translateText,
  getKotakRecaptureCase,
  getAspectRatioClientList,
  setConstraint,
  makeRequest,
  getLumaBlurScore,
  checkUploadingStatusPorto,
  setAckoCompletionRedisTag,
  setNewCompleteRedisTag,
  getOtherModuleFlag,
  getOtherModuleCount
} from "../context/utils";
import Button from "./Button";
import loadingGif from "../img/loading.gif";
import allowedImg from "../img/allowed.png";
import deniedImg from "../img/denied.png";
import JarvisTracking from "./JarvisTracking";
import { inkOn } from "../utils_new/theme";
let portoInterval
// liberty_dev's menu has a back button to this screen, so initialize() can run
// more than once in a session; the upload loop only needs starting the once.
let uploadLoop = null;
let FormModuleExist = false;
let logsbugs = true;
let moduleSelect = false;
let logData = {
  position: 1,
  camera_permission: "",
  gyro_permission: "",
  location_permission: "",
  desktop_view: "no",
  inspectionId: "",
};
let rotate = true;
let flag = true;
let audioPermissions = false;
let stopCont = true;
let gyroAnglesLogged = false;
let checkHiibData = false;
// geolocation: how long the browser may search for a position once the user
// has allowed it, and how long we wait for any answer at all before telling
// the user what to check (getCurrentPosition can otherwise spin forever)
const LOCATION_FIX_TIMEOUT = 10000;
const LOCATION_NO_RESPONSE_TIMEOUT = 20000;
// iPhone browsers can't say whether the user blocked a site, so a refusal
// faster than this (no prompt was on screen) is put down to phone settings
const LOCATION_AUTO_DENY_MS = 1000;
const LOCATION_DENIED_KEY = "inspektLocationUserDenied"; // localStorage
let startImageData =
  "data:image/jpeg;base64,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";
const Instructions = () => {
  const {
    showAlert,
    config,
    setScreen,
    inspectionId,
    setAutoRotate,
    setLocation,
    setHiibCustomValue,
    token,
    clientId,
    caseId,
    setCurrentBlock,
  } = useContext(AppContext);
  const ackoLogs = useRef();
  const locationTimer = useRef(null);
  const locationAskedAt = useRef(0);
  const locationLate = useRef(false); // no-response warning already shown
  const locationOk = useRef(false);
  const locationSiteBefore = useRef(null); // site permission when Allow was tapped
  const land = () => window.innerWidth > window.innerHeight * 1.2;
  const [cameraWarning, setCameraWarning] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [permissionStep, setPermissionStep] = useState(false);
  const [locationPermission, setLocationPermission] = useState(null);
  const [gyroPermission, setGyroPermission] = useState(null);
  const [cameraPermission, setCameraPermission] = useState(null);
  const [switchBtn, setSwitchBtn] = useState(1);
  const [screenHeight, setScreenHeight] = useState(land() ? false : true);

  if (logsbugs) {
    patLogs("Entered to Instructions page", getInspectionID(), "instruction");
    userLogs({
      position: 8,
      last_page: "instruction page",
      inspectionId: getInspectionID(),
      pos: "instruction",
    });
  }

  window.onresize = () => {
    setScreenHeight(land() ? false : true);
  };

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text)) {
      return config["language"][text];
    } else {
      // const data = translateText(text, config["language"]["langCode"]);
      return text;
    }
  };

  logsbugs = false;
  const initialize = async () => {
    // if (["porto_seguros", "porto_seguros_uat"].includes(clientId)) {
    clearInterval(portoInterval);
    portoInterval = setInterval(() => {
      let d = checkUploadingStatusPorto();
      if (d) {
        // console.log("all Success")
        clearInterval(portoInterval)
        // patLogs("Uploading_criteria", inspectionId);
        setNewCompleteRedisTag()
      }
    }, 100);
    // }
    if (clientId === "client_hiib" || clientId === "client_hiib_uat") {
      if (checkHiibData) {
        let d = await gethiibMssg({ token: token, client_id: clientId });
        if (d.status) {
          setHiibCustomValue(d.value);
        }
      }
    }
    if (
      ["client_594", "client_594_uat", ""].includes(clientId) &&
      Object.keys(config).includes("allowPortraitApp")
    ) {
      try {
        makeRequest(`/wondleFlag/${inspectionId}`);
      } catch (err) {
        // console.log("error faces while setting wondle flag in redis :: ", err);
      }
    }
    if (Object.keys(config).includes("resolution")) {
      setResizing([true, config["resolution"]]);
    }
    Object.keys(config).includes("vmgFLowType") &&
      setVmgFlowType(config["vmgFLowType"]);
    Object.keys(config).includes("vmgUrl") && setVmgUrl(config["vmgUrl"]);
    Object.keys(config).includes("authorization") &&
      setAuthorization(config["authorization"]);
    Object.keys(config).includes("customHiibVmg") &&
      setCustomHiibVmg(config["customHiibVmg"]);
    if (!uploadLoop) {
      uploadLoop = Object.keys(config).includes("directModule")
        ? setInterval(() => imageUpload(getInspectionID()), 2000)
        : !getKotakRecaptureCase() &&
        setInterval(() => imageUpload(inspectionId), 2000);
    }
    if (
      Object.keys(config).includes("form-page") &&
      !Object.keys(config).includes("allowPortraitApp")
    ) {
      if (FormModuleExist) {
        if (["opes_prod", "opes_uat"].includes(clientId)) {
          setScreen("menuOpes");
        } else {
          setScreen("menu");
        }
      } else {
        getKotakRecaptureCase() ? setScreen("menu") : setScreen("form");
      }
    } else if (
      Object.keys(config).includes("allowPortraitApp") &&
      config["allowPortraitApp"]
    ) {
      // setScreen("pMenu");
      setScreen("block");
      setCurrentBlock(config["blocks"][0]);
    } else {
      if (["opes_prod", "opes_uat"].includes(clientId)) {
        setScreen("menuOpes");
      } else {
        Object.keys(config).includes("kotak-vehicle-page") && !getKotakRecaptureCase() ? setScreen("VehicleInfo") : setScreen("menu");
      }
    }
    config["blocks"].map((e) => {
      if (e["name"] === "Video Capture") {
        Object.keys(config["video-page"]).includes(
          "clientRegion"
        )
          ? config["video-page"]["clientRegion"]
          : "eu";
      }
    });
    setLoading(false);
  };

  const askPermission = () => {
    setDisabled(true);
    config["blocks"].map((e) => {
      if (
        e["name"] === "Video Capture" ||
        e["name"] === "New Video Capture" ||
        e["name"] === "VinOdo Video Capture" ||
        e["name"] === "NewVinOdo Video Capture" ||
        e["name"] === "Stencil Video" ||
        e["name"] === "New Image App"
      ) {
        moduleSelect = true;
        let payload = {
          inspection_id: inspectionId,
          client_id: clientId,
          region: "eu-central-1",
          env: 1,
          image: startImageData.replace(/^data:image\/jpeg;base64,/, ""),
        };

        getLumaBlurScore(payload);
      }
      if (e["name"] === "Video Recorder" && e["audioRecording"]) {
        audioPermissions = true;
      }
      if (e["name"] === "Form Module") {
        FormModuleExist = true;
      }
      if (e["name"] === "Custom Hiib Module") {
        checkHiibData = true;
      }
      if (
        (e["tag"] === "360 Image" &&
          Object.keys(config).includes("imageFeedback")) ||
        e["name"] === "New Image App" || e["tag"] === "VIN"
      ) {
        imageFeedbackLambda({
          inspection_id: inspectionId,
          image: startImageData.replace(/^data:image\/jpeg;base64,/, ""),
          tag: "testing",
          type: Object.keys(e).includes("type") && e["type"] === "bike" ? "bike" : e["tag"] === "VIN" ? "VIN" : "car",
          client_id: clientId,
          new_image_app: e["name"] === "New Image App" ? true : false,
          Vin_feedback: true,
          region: "eu-central-1",
          env: 1
        });
      }
      if (getOtherModuleFlag() && flag) {
        makeRequest(`/setOtherModuleRedis/${inspectionId}/${getOtherModuleCount() + ""}`);
        flag = false;
      }
      if (e["name"] === "ImageUpload") {
        rotate = false;
      }
    });
    //patLogs("Proceed button clicked", inspectionId);
    setPermissionStep(true);
  };

  const getIosBrowser = (ua) => {
    if (/CriOS/i.test(ua)) return "chrome";
    if (/FxiOS/i.test(ua)) return "firefox";
    if (/EdgiOS/i.test(ua)) return "edge";
    if (/OPiOS|OPT\//i.test(ua)) return "opera";
    return "safari";
  };

  // picks the first config key that exists, else falls back to the hardcoded text
  const pushWarning = (keys, fallbackText, type) => {
    const key = keys.find((k) => Object.keys(config["errors"]).includes(k));
    setCameraWarning((prev) => [
      ...prev,
      {
        type: type,
        warning: key ? config["errors"][key] : getTranslateText(fallbackText),
      },
    ]);
  };

  const checkCameraPermission = async () => {
    patLogs("camera allow button clicked", inspectionId);
    setCameraPermission("loading");
    const ua = navigator.userAgent;
    const isIos = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const isAndroid = /Android/.test(ua);

    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: audioPermissions,
      });
      mediaStream.getTracks().forEach((track) => {
        track.stop();
      });
      logData.camera_permission = "yes";
      setCameraPermission(true);
      //sendLogData(logData);
    } catch (error) {
      logData.camera_permission = "no";
      setCameraPermission(false);
      sendLogData(logData);
      if (isIos) {
        const iosBrowser = getIosBrowser(ua);
        if (iosBrowser === "chrome") {
          pushWarning(
            ["camera_error_ios_chrome", "camera_error_ios"],
            "Camera is already in use by another application or tab, or blocked. \niPhone Settings > Chrome > turn on Camera. \nIn Chrome, tap the three dots at bottom right > Settings > Content Settings > Camera > Allow for https://superapp.inspektlabs.com \n(Refresh the link and allow all Permission)",
            "camera"
          );
        } else if (iosBrowser === "edge") {
          pushWarning(
            ["camera_error_ios_edge", "camera_error_ios"],
            "Camera is already in use by another application or tab, or blocked. \niPhone Settings > Edge > turn on Camera. \n(Refresh the link and allow all Permission)",
            "camera"
          );
        } else if (iosBrowser === "opera") {
          pushWarning(
            ["camera_error_ios_opera", "camera_error_ios"],
            "Camera is already in use by another application or tab, or blocked. \niPhone Settings > Opera > turn on Camera. \n(Refresh the link and allow all Permission)",
            "camera"
          );
        }
        else {
          pushWarning(
            ["camera_error_ios"],
            "Camera is already in use by another application or tab. or blocked \nSetting > Safari > Clear History and Website Data > keep Tabs. (Refresh the link and allow all Permission)",
            "camera"
          );
        }
      } else if (isAndroid && navigator.userAgent.includes("Samsung")) {
        pushWarning(
          ["camera_error_samsung"],
          "Camera is already in use by another application or tab. or blocked \nAt bottom right corner, click on three horizontal lines of Samsung menu > Sites and Downloads > Site Permission > Camera > switch it on \n blocked > https://superapp.inspektlabs.com > Allow. \n (Refresh the link and allow all Permission)",
          "camera"
        );
      } else if (isAndroid && navigator.userAgent.includes("Edg")) {
        pushWarning(
          ["camera_error_edge"],
          "Camera is already in use by another application or tab. or blocked \nAt bottom right corner, click on three horizontal lines > Settings > Privacy and Security > Site Settings > Camera > switch it on \n blocked > https://superapp.inspektlabs.com > Allow. \n (Refresh the link and allow all Permission)",
          "camera"
        );
      } else if (isAndroid) {
        pushWarning(
          ["camera_error_android"],
          "Camera is already in use by another application or tab. or blocked \nAt right top corner, click on three dots of chrome > settings > site settings > camera > switch it on \n blocked > https://superapp.inspektlabs.com > Allow. \n (Refresh the link and allow all Permission)",
          "camera"
        );
      }
    }
  };

  // Function to update logs in the UI
  const updateLogs = (deviceOrientation) => {
    if (ackoLogs.current) {
      ackoLogs.current.innerHTML = `
      DeviceOrientationEvent: alpha=${deviceOrientation.alpha}, beta=${deviceOrientation.beta}, gamma=${deviceOrientation.gamma}
    `;
    }
  };

  /**
   * Log the raw device orientation once, right after the gyro permission is
   * granted. Reads the values exactly the way AngleGyroEstimator does (the
   * deviceorientation event, alpha / beta / gamma), so what is logged here is
   * what the model will later work with. beta / gamma / alpha are the rotations
   * around the X / Y / Z axes. Same path on iOS and Android: by the time this
   * runs the permission has been granted, so the event fires on both.
   */
  const logGyroAngles = () => {
    try {
      if (gyroAnglesLogged) return;

      if (window.DeviceOrientationEvent) {
        const r = (n) =>
          n === undefined || n === null || isNaN(n) ? "-" : Math.round(n);
        let gyroLogTimer = null;

        const onOrientation = (event) => {
          if (gyroAnglesLogged) return;
          // Android hands out an event with null values when the sensor is
          // blocked; wait for a real reading.
          if (event.alpha === null && event.beta === null && event.gamma === null)
            return;
          gyroAnglesLogged = true;
          window.removeEventListener("deviceorientation", onOrientation);
          clearTimeout(gyroLogTimer);
          patLogs(
            `gyro angle x=${r(event.beta)} y=${r(event.gamma)} z=${r(
              event.alpha
            )}`,
            inspectionId
          );
        };

        window.addEventListener("deviceorientation", onOrientation);

        // Permission granted but the sensor never reports: say so instead of
        // logging nothing at all.
        gyroLogTimer = setTimeout(() => {
          if (gyroAnglesLogged) return;
          gyroAnglesLogged = true;
          window.removeEventListener("deviceorientation", onOrientation);
          patLogs("gyro angle no reading", inspectionId);
        }, 3000);
      } else {
        gyroAnglesLogged = true;
        patLogs("gyro angle not supported in this browser", inspectionId);
      }
    } catch (e) {
      /* telemetry only */
    }
  };

  const checkGyroPermission = async () => {
    stopCont = true;
    patLogs("gyro button clicked", inspectionId);
    setGyroPermission("loading");
    const ua = navigator.userAgent;
    const isIos = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const isAndroid = /Android/.test(ua);
    if (
      Object.keys(config).includes("directModule") &&
      config["directModule"] === false
    ) {
      if (
        typeof DeviceMotionEvent !== "undefined" &&
        typeof DeviceMotionEvent.requestPermission === "function"
      ) {
        try {
          const permissionState = await DeviceMotionEvent.requestPermission();
          if (permissionState === "granted") {
            if (stopCont) {
              stopCont = false;
              logData.gyro_permission = "yes";
              setGyroPermission(true);
              logGyroAngles();
              let deviceOrientation = { alpha: 0, beta: 0, gamma: 0 };
              // Handle Device Orientation separately
              if (window.DeviceOrientationEvent) {
                window.addEventListener("deviceorientation", (event) => {
                  deviceOrientation = {
                    alpha: event.alpha,
                    beta: event.beta,
                    gamma: event.gamma,
                  };
                  updateLogs(deviceOrientation); // Update logs whenever orientation changes
                });
              }
            }
          } else if (
            permissionState === "denied" ||
            permissionState === "dismissed"
          ) {
            logData.gyro_permission = "no";
            setGyroPermission(false);
            sendLogData(logData);
            setCameraWarning([
              ...cameraWarning,
              {
                type: "gyro",
                warning:
                  config["errors"]["motion_sensor_safari"] ||
                  getTranslateText(
                    "Motion Sensor permission denied.\nSetting > Safari > Clear History and Website Data > keep Tabs. (Refresh the link and allow all Permission)"
                  ),
              },
              (ackoLogs.current.innerHTML = `
                    Android = ${isAndroid}, 
                    iOS = ${isIos}, 
                    Motion Sensor permission denied`),
            ]);
          }
        } catch (error) {
          ackoLogs.current.innerHTML = `
                    Android = ${isAndroid}, 
                    iOS = ${isIos}, 
                    Gyroscope API is not supported on iOS`;
          setCameraWarning([
            ...cameraWarning,
            {
              type: "gyro",
              warning:
                config["errors"]["motion_sensor_not_support_safari"] ||
                getTranslateText("Gyroscope API is not supported on iOS"),
            },
          ]);
          logData.gyro_permission = error.message;
          setGyroPermission(false);
          sendLogData(logData);
        }
      } else {
        ackoLogs.current.innerHTML = `
                    Android = ${isAndroid}, 
                    iOS = ${isIos}, 
                    Gyroscope API is not supported on iOS`;
        logData.gyro_permission = "Gyroscope API is not supported on iOS";
        setGyroPermission(false);
        sendLogData(logData);
        setCameraWarning([
          ...cameraWarning,
          {
            type: "gyro",
            warning:
              config["errors"]["motion_sensor_not_support_safari"] ||
              getTranslateText("Gyroscope API is not supported on iOS"),
          },
        ]);
      }
    } else if (isIos) {
      if (
        typeof DeviceMotionEvent !== "undefined" &&
        typeof DeviceMotionEvent.requestPermission === "function"
      ) {
        try {
          const permissionState = await DeviceMotionEvent.requestPermission();
          if (permissionState === "granted") {
            if (stopCont) {
              stopCont = false;
              logData.gyro_permission = "yes";
              setGyroPermission(true);
              logGyroAngles();
              //sendLogData(logData);
            }
          } else if (permissionState === "denied" || permissionState === "dismissed") {
            logData.gyro_permission = "no";
            setGyroPermission(false);
            sendLogData(logData);
            const iosBrowser = getIosBrowser(ua);
            if (iosBrowser === "chrome") {
              pushWarning(
                ["motion_sensor_chrome"],
                "Motion Sensor permission denied.\nSetting > Chrome > Clear History and Website Data > keep Tabs. (Refresh the link and allow all Permission)",
                "gyro"
              );
            } else if (iosBrowser === "edge") {
              pushWarning(
                ["motion_sensor_edge"],
                "Motion Sensor permission denied.\nSetting > Edge > Clear History and Website Data > keep Tabs. (Refresh the link and allow all Permission)",
                "gyro"
              );
            } else if (iosBrowser === "opera") {
              pushWarning(
                ["motion_sensor_opera"],
                "Motion Sensor permission denied.\nSetting > Opera > Clear History and Website Data > keep Tabs. (Refresh the link and allow all Permission)",
                "gyro"
              );
            }
            else {
              pushWarning(
                ["motion_sensor_safari"],
                "Motion Sensor permission denied.\nSetting > Safari > Clear History and Website Data > keep Tabs. (Refresh the link and allow all Permission)",
                "gyro"
              );
            }
          }
        } catch (error) {
          logData.gyro_permission = error.message;
          setGyroPermission(false);
          sendLogData(logData);
          pushWarning(
            ["motion_sensor_not_support_safari"],
            "Gyroscope API is not supported on iOS",
            "gyro"
          );
        }
      } else {
        logData.gyro_permission = "Gyroscope API is not supported on iOS";
        setGyroPermission(false);
        sendLogData(logData);
        pushWarning(
          ["motion_sensor_not_support_safari"],
          "Gyroscope API is not supported on iOS",
          "gyro"
        );
      }
    } else if (isAndroid && navigator.userAgent.includes("Samsung")) {
      try {
        if (window.DeviceOrientationEvent) {
          window.addEventListener("deviceorientation", (event) => {
            if (
              (event.alpha === null, event.beta === null, event.gamma === null)
            ) {
              pushWarning(
                ["motion_sensor_samsung"],
                "Gyro permission is denied \nAt bottom right corner, click on three horizontal lines (menu) > Settings > Sites and Downloads > Site permissions > Motion sensor > Switch it on",
                "gyro"
              );
              if (stopCont) {
                logData.gyro_permission = "no";
                setGyroPermission(false);
                sendLogData(logData);
                stopCont = false;
              }
            } else {
              if (stopCont) {
                logData.gyro_permission = "yes";
                setGyroPermission(true);
                logGyroAngles();
                //sendLogData(logData);
                stopCont = false;
              }
            }
          });
        } else {
          logData.gyro_permission = "no";
          setGyroPermission(false);
          sendLogData(logData);
          pushWarning(
            ["motion_sensor_not_support_samsung"],
            "DeviceOrientationEvent (gyro) not supported in this browser.",
            "gyro"
          );
        }
      } catch (error) {
        logData.gyro_permission = "no";
        setGyroPermission(false);
        sendLogData(logData);
        pushWarning(
          ["motion_sensor_samsung"],
          "Gyro permission is denied \nAt bottom right corner, click on three horizontal lines (menu) > Settings > Sites and Downloads > Site permissions > Motion sensor > Switch it on",
          "gyro"
        );
      }
    } else if (isAndroid && navigator.userAgent.includes("Edg")) {
      try {
        if (window.DeviceOrientationEvent) {
          window.addEventListener("deviceorientation", (event) => {
            if (
              (event.alpha === null, event.beta === null, event.gamma === null)
            ) {
              if (stopCont) {
                logData.gyro_permission = "no";
                setGyroPermission(false);
                sendLogData(logData);
                stopCont = false;
              }
              pushWarning(
                ["motion_sensor_edge"],
                "Gyro permission is denied \nAt bottom right corner, click on three horizontal lines (menu) > Settings > Privacy and Security > Site Settings > Motion sensor > Switch it on",
                "gyro"
              );
            } else {
              if (stopCont) {
                logData.gyro_permission = "yes";
                setGyroPermission(true);
                logGyroAngles();
                //sendLogData(logData);
                stopCont = false;
              }
            }
          });
        } else {
          logData.gyro_permission = "no";
          setGyroPermission(false);
          sendLogData(logData);
          pushWarning(
            ["motion_sensor_not_support_edge"],
            "DeviceOrientationEvent (gyro) not supported in this browser.",
            "gyro"
          );
        }
      } catch (error) {
        logData.gyro_permission = "no";
        setGyroPermission(false);
        sendLogData(logData);
        pushWarning(
          ["motion_sensor_edge"],
          "Gyro permission is denied \nAt bottom right corner, click on three horizontal lines (menu) > Settings > Privacy and Security > Site Settings > Motion sensor > Switch it on",
          "gyro"
        );
      }
    } else if (isAndroid) {
      try {
        if (window.DeviceOrientationEvent) {
          window.addEventListener("deviceorientation", (event) => {
            if (
              (event.alpha === null, event.beta === null, event.gamma === null)
            ) {
              if (stopCont) {
                logData.gyro_permission = "no";
                setGyroPermission(false);
                sendLogData(logData);
                stopCont = false;
              }
              pushWarning(
                ["motion_sensor_chrome"],
                "Gyro permission is denied \nAt right top corner, click on three dots of chrome > settings > site settings > motion sensor > switch it on",
                "gyro"
              );
            } else {
              if (stopCont) {
                logData.gyro_permission = "yes";
                setGyroPermission(true);
                logGyroAngles();
                //sendLogData(logData);
                stopCont = false;
              }
            }
          });
        } else {
          logData.gyro_permission = "no";
          setGyroPermission(false);
          sendLogData(logData);
          pushWarning(
            ["motion_sensor_not_support_chrome"],
            "DeviceOrientationEvent (gyro) not supported in this browser.",
            "gyro"
          );
        }
      } catch (error) {
        logData.gyro_permission = "no";
        setGyroPermission(false);
        sendLogData(logData);
        pushWarning(
          ["motion_sensor_chrome"],
          "Gyro permission is denied \nAt right top corner, click on three dots of chrome > settings > site settings > motion sensor > switch it on",
          "gyro"
        );
      }
    }
  };

  const checkDesktopView = () => {
    let isIos =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    let isAndroid = /Android/.test(navigator.userAgent);
    if (isIos === false && isAndroid === false && !Object.keys(config).includes("enable-desktop")) {
      setDisabled(true);
      logData.desktop_view = "yes";
      // sendLogData(logData);
      pushWarning(
        ["desktop_view_enabled"],
        "Desktop View is enabled.\nIos -> Setting > Safari > Request Desktop Website > All Websites (Turn it Off). refresh the link\nAndroid -> Chrome Setting > Site settings > Desktop site (Turn it off). Refresh the link\nAndroid -> Samsung Browser Setting > Settings > Advanced > Desktop site (Turn it off). Refresh the link\nAndroid -> Edge Browser Setting > Settings > General > Site display settings > Desktop site (Turn it off). Refresh the link",
        "desktop"
      );
    } else {
      askPermission();
    }
  };

  // which settings screens to point the user at
  const getLocationEnv = () => {
    const ua = navigator.userAgent;
    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      return { os: "ios", browser: getIosBrowser(ua) };
    }
    if (/Android/.test(ua)) {
      if (ua.includes("Samsung")) return { os: "android", browser: "samsung" };
      if (ua.includes("Edg")) return { os: "android", browser: "edge" };
      return { os: "android", browser: "chrome" };
    }
    return { os: "desktop", browser: "" };
  };

  // Built-in "how to turn location on" for each OS + browser. Location can be
  // off in three places: the phone, the browser app, and the site inside the
  // browser. {site} is filled in with this page's host.
  const getLocationSteps = ({ os, browser }) => {
    if (os === "ios") {
      if (browser === "safari") {
        return getTranslateText("To turn on location: iPhone Settings > Apps > Safari > Location > Ask or Allow (iOS 17 or older: iPhone Settings > Safari > Location) (Refresh the link and allow all permissions)");
      }
      // Chrome on iPhone has no per-site location setting, so for the other
      // iPhone browsers point at the iOS switch, which applies to all of them
      const app = { chrome: "Chrome", edge: "Edge", firefox: "Firefox", opera: "Opera" }[browser];
      return getTranslateText("To turn on location: iPhone Settings > Apps > browser you are using [chrome] > Location > turn it on. (Refresh the link and allow all permissions. If it is still blocked, open the link in Safari)");
    }
    if (os === "android") {
      // location has to be allowed in both places: in the browser for this
      // site, and for the browser app in the phone's settings
      const site = {
        chrome:
          getTranslateText("To turn on location: In Chrome, tap the 3 dots (⋮) next to the address bar > Settings > Site settings > Location > turn it on. If {site} is listed as blocked, tap it > Allow. (Refresh the link and allow all permissions)"),
        samsung:
          getTranslateText("To turn on location: In Samsung Internet, tap the 3 lines (≡) at the bottom right > Settings > Sites and downloads > Site permissions > Location. If {site} is listed, switch it on. (Refresh the link and allow all permissions)"),
        edge:
          getTranslateText("To turn on location: In Edge, tap the menu (3 lines ≡ or 3 dots ⋯) at the bottom > Settings > Privacy and security > Site permissions > Location > turn it on. If {site} is listed as blocked, tap it > Allow. (Refresh the link and allow all permissions)"),
      }[browser];
      return (
        site
        // "\n" +
        // getTranslateText("To turn on location: Phone Settings > Apps > browser you are using > Permissions > Location > Allow only while using the app. (Refresh the link and allow all permissions)")
      );
    }
    return getTranslateText("To turn on location: Click the lock or settings icon on the left of the address bar > Site settings or Permissions > Location > Allow. (Refresh the link and allow all permissions)");
  };

  // Built-in text for the cases where the permission was not the problem.
  // Whole sentences, so each one is a single entry in the language file.
  const getLocationCauseText = (cause, { os }) => {
    if (cause === "phone_not_supported") {
      return os === "ios"
        ? getTranslateText("Location is not available in this browser. Please open the link in Safari.")
        : getTranslateText("Location is not available in this browser. Please open the link in Chrome.");
    }
    if (os === "ios")
      return getTranslateText("Your location could not be found.\nPlease make sure Location is turned on (iPhone Settings > Privacy & Security > Location Services) and you are connected to the internet.\n(Refresh the link and try again)");
    if (os === "android")
      return getTranslateText("Your location could not be found.\nPlease make sure Location is turned on (Phone Settings > Location) and you are connected to the internet.\n(Refresh the link and try again)");
    return getTranslateText("Your location could not be found.\nPlease make sure Location is turned on in your computer's privacy settings and you are connected to the internet.\n(Refresh the link and try again)");
  };

  // Every client gets the same built-in text, translated through the language
  // file (backend/controller/config.json); no per-client location texts.
  // code: user_denied | phone_denied | no_response | position_unavailable | phone_not_supported
  const showLocationWarning = (code, env) => {
    let warning;
    if (code === "user_denied" || code === "phone_denied" || code === "no_response") {
      // what happened + the steps for this phone and browser
      const firstLine = {
        user_denied: getTranslateText("Location permission is denied."),
        phone_denied: getTranslateText("Location is turned off on your phone or not allowed for this browser."),
        no_response: getTranslateText("We did not get a response for your location."),
      }[code];
      warning = firstLine + "\n" + getLocationSteps(env);
    } else {
      warning = getLocationCauseText(code, env);
    }
    warning = String(warning).replace(/\{site\}/g, window.location.hostname);
    // replace, not append: a late answer swaps out the no-response warning
    setCameraWarning((prev) => [
      ...prev.filter((e) => e.type !== "loaction"),
      { type: "loaction", warning: warning },
    ]);
  };

  // the browser's stored answer for this site: granted / denied / prompt
  const querySitePermission = () => {
    const query = (async () => {
      try {
        if (navigator.permissions && navigator.permissions.query) {
          return (await navigator.permissions.query({ name: "geolocation" })).state;
        }
      } catch (e) {
        /* this browser can't query the geolocation permission */
      }
      return "unknown";
    })();
    // a stuck query must not hold up the warning
    const giveUp = new Promise((resolve) => setTimeout(() => resolve("unknown"), 1000));
    return Promise.race([query, giveUp]);
  };

  // iPhone browsers remember a "Don't Allow" and refuse instantly on the
  // next visit, which looks just like the phone refusing, so remember the
  // user's no ourselves
  const setUserDeniedBefore = (denied) => {
    try {
      if (denied) localStorage.setItem(LOCATION_DENIED_KEY, "1");
      else localStorage.removeItem(LOCATION_DENIED_KEY);
    } catch (e) {
      /* storage blocked (private mode etc.) */
    }
  };
  const getUserDeniedBefore = () => {
    try {
      return localStorage.getItem(LOCATION_DENIED_KEY) === "1";
    } catch (e) {
      return false;
    }
  };

  // Who refused (error code 1)?
  // Android: the site's stored answer is reliable. It is "denied" only after
  // the user tapped Don't allow (now or earlier). Anything else means the site
  // was not blocked, so the phone refused: location off (this includes
  // "Continue" on Chrome's location-is-off popup) or the browser not allowed.
  // iPhone: browsers say "prompt" even after Don't Allow, so timing decides.
  // An instant refusal never showed a prompt, so the phone's settings blocked
  // it (Safari with location off), unless this user said no here before.
  const getDeniedCode = (env, site, elapsed) => {
    if (site === "granted") return "phone_denied";
    if (env.os !== "ios" && site === "denied") return "user_denied";
    if (env.os !== "ios" && site === "prompt") return "phone_denied";
    if (elapsed >= LOCATION_AUTO_DENY_MS) return "user_denied";
    return getUserDeniedBefore() ? "user_denied" : "phone_denied";
  };

  // cause: denied | timeout | no_response | position_unavailable | phone_not_supported
  const locationFailed = async (cause, error, elapsed) => {
    const env = getLocationEnv();
    const site = await querySitePermission();
    const siteBefore = await (locationSiteBefore.current || "unknown");
    if (locationOk.current) return; // a late position arrived meanwhile
    // Allowed, but no position within 10s: the phone's location is off
    // (Chrome still shows its Allow popup when it is).
    const code =
      cause === "denied"
        ? getDeniedCode(env, site, elapsed)
        : cause === "timeout"
          ? "phone_denied"
          : cause;
    if (code === "user_denied") setUserDeniedBefore(true);
    setLocation({ latitude: 0, longitude: 0 });
    setLocationPermission(false);
    showLocationWarning(code, env);
    logData.location_permission = code;
    sendLogData(logData);
    // the raw signals behind the user/phone call, to check it on real devices
    patLogs(
      `location permission failed - ${code} (error ${error ? error.code : "-"}, ${elapsed}ms, site ${siteBefore}>${site})`,
      inspectionId
    );
  };

  const CheckLocationPermission = () => {
    patLogs("location allow button clicked", inspectionId);
    setLocationPermission("loading");
    if (!navigator.geolocation) {
      locationFailed("phone_not_supported", null, 0);
      return;
    }
    locationOk.current = false;
    locationLate.current = false;
    locationAskedAt.current = Date.now();
    locationSiteBefore.current = querySitePermission();
    clearTimeout(locationTimer.current);
    // Some browsers never call back (prompt dismissed, OS dialog closed, GPS
    // stuck). Stop the loader and tell the user what to check; a late answer
    // is still taken by locationSuccess / locationError.
    locationTimer.current = setTimeout(() => {
      locationLate.current = true;
      locationFailed("no_response", null, Date.now() - locationAskedAt.current);
    }, LOCATION_NO_RESPONSE_TIMEOUT);
    navigator.geolocation.getCurrentPosition(locationSuccess, locationError, {
      timeout: LOCATION_FIX_TIMEOUT,
    });
  };

  const locationSuccess = (pos) => {
    clearTimeout(locationTimer.current);
    locationOk.current = true;
    setUserDeniedBefore(false);
    logData.location_permission = "yes";
    if (locationLate.current) {
      // came in after the no-response warning: take the warning back and
      // correct the no_response that was already logged
      setCameraWarning((prev) => prev.filter((e) => e.type !== "loaction"));
      patLogs(
        `location permission - yes (late, ${Math.round(
          (Date.now() - locationAskedAt.current) / 1000
        )}s)`,
        inspectionId
      );
      sendLogData(logData);
    }
    setLocationPermission(true);
    initializeLocation({
      latitude: pos.coords.latitude,
      longitude: pos.coords.longitude,
    });
    setLocation({
      latitude: pos.coords.latitude,
      longitude: pos.coords.longitude,
    });
    // console.log("PERMISSION_GRANTED");
  };

  const locationError = (error) => {
    clearTimeout(locationTimer.current);
    const elapsed = Date.now() - locationAskedAt.current;
    // error.code: 1 PERMISSION_DENIED, 2 POSITION_UNAVAILABLE, 3 TIMEOUT
    const cause =
      error && error.code === 2
        ? "position_unavailable"
        : error && error.code === 3
          ? "timeout"
          : "denied";
    locationFailed(cause, error, elapsed);
  };
  const sendMessageIFrame = () => {
    // added event
    window.top.postMessage("rotation", "*");
  };
  const switchLandscape = () => {
    if ((Object.keys(config).includes("form-page") && FormModuleExist === false) || (Object.keys(config).includes("kotak-vehicle-page") && !getKotakRecaptureCase())) {
      initialize();
    }
    else {
      if (clientId !== "autogroup") sendMessageIFrame();
      sendLogData(logData);
      setLoading(true);
      let isAndroid = /Android/.test(navigator.userAgent) || false;
      // if (getAspectRatioClientList().includes(clientId)) {
      //   setConstraint(config, true, isAndroid ? "android" : "ios");
      // }
      // else {
      //   setConstraint(config, false);
      // }
      if (isAndroid) {
        const element = document.documentElement;
        if (element.requestFullscreen) {
          element
            .requestFullscreen()
            .then(async () => {
              if (
                Object.keys(config).includes("allowPortraitApp") &&
                screen.orientation &&
                screen.orientation.lock
              ) {
                screen.orientation
                  .lock("portrait")
                  .then(function success() {
                    initialize();
                    //patLogs("switch to landscape", inspectionId);
                  })
                  .catch(function error(e) {
                    // console.log(e.message);
                    initialize();
                  });
              } else if (
                Object.keys(config).includes("allowPortraitApp") &&
                window.screen &&
                window.screen.orientation &&
                window.screen.orientation.lock
              ) {
                window.screen.orientation
                  .lock("portrait")
                  .then(function success() {
                    initialize();
                    //patLogs("switch to landscape", inspectionId);
                  })
                  .catch(function error(e) {
                    // console.log(e.message);
                    initialize();
                  });
              } else if (screen.orientation && screen.orientation.lock) {
                try {
                  const lockPromise = screen.orientation.lock("landscape");

                  const timeout = new Promise((resolve) =>
                    setTimeout(() => resolve("timeout"), 1000)
                  );

                  const result = await Promise.race([
                    lockPromise.then(() => "locked"),
                    timeout
                  ]);

                  if (result === "locked") {
                    setAutoRotate(true);
                  } else {
                    // timeout happened
                    setAutoRotate(false);
                  }

                  initialize();
                } catch (e) {
                  // console.log("Orientation lock failed:", e);
                  setAutoRotate(false);
                  initialize();
                }
              } else if (
                window.screen &&
                window.screen.orientation &&
                window.screen.orientation.lock
              ) {
                window.screen.orientation
                  .lock("landscape")
                  .then(function success() {
                    initialize();
                    //patLogs("switch to landscape", inspectionId);
                  })
                  .catch(function error(e) {
                    // console.log(e.message);
                    initialize();
                  });
              } else {
                initialize();
              }
            })
            .catch((error) => {
              if (Object.keys(config).includes("directModule")) {
                setAutoRotate(true);
              }
              initialize();
            });
        } else {
          initialize();
        }
      } else {
        initialize();
      }
      if (clientId === "autogroup" || ["autogroup"].includes(clientId)) {
        initialize();
      }
    }
  };

  const sendLogData = async (data) => {
    await userLogs(data);
  };

  // liberty_dev's back arrow: from the permission step back to the
  // instructions, and from the instructions back to the claim page. Permissions
  // already given are kept, so Continue goes straight through them next time.
  const backBtn = () => {
    if (permissionStep) {
      patLogs("Back button clicked on permission page", inspectionId);
      setPermissionStep(false);
      setSwitchBtn(1);
      setDisabled(false);
      return;
    }
    patLogs("Back button clicked on instruction page", inspectionId);
    clearTimeout(locationTimer.current);
    setScreen("Liberty");
  };

  useEffect(() => {
    logData.inspectionId = getInspectionID();
    if (moduleSelect === false && cameraPermission === true) {
      if (Object.keys(config).includes("restrictionforLocationPermission")) {
        if (config["restrictionforLocationPermission"] === true) {
          if (locationPermission === true) {
            setDisabled(false);
          } else {
            setDisabled(true);
          }
        } else {
          setDisabled(false);
        }
      } else {
        setDisabled(false);
      }
    }
    if (
      moduleSelect === true &&
      gyroPermission === true &&
      cameraPermission === true
    ) {
      if (Object.keys(config).includes("restrictionforLocationPermission")) {
        if (config["restrictionforLocationPermission"] === true) {
          if (locationPermission === true) {
            setDisabled(false);
          } else {
            setDisabled(true);
          }
        } else {
          setDisabled(false);
        }
      } else {
        setDisabled(false);
      }
    }
    if (Object.keys(config).includes("directModule")) {
      if (
        !config["directModule"] &&
        moduleSelect === true &&
        gyroPermission === true
      ) {
        setDisabled(false);
      }
    }
  }, [
    locationPermission,
    gyroPermission,
    cameraPermission,
    setCameraWarning,
    cameraWarning,
    // Back from the permission step and Continue again: the permissions are
    // already settled, so nothing above changes and Continue would stay disabled.
    permissionStep,
  ]);

  useEffect(() => {
    if (clientId !== "autogroup") window.top.postMessage("gyro", "*");
    logData.inspectionId = getInspectionID();
    if (Object.keys(config).includes("directModule")) {
      if (clientId === "arval_dev" || clientId === "arval_prod") {
        checkDesktopView();
      }
      else if (config["directModule"]) {
        setTimeout(() => {
          switchLandscape();
        }, 1000);
      } else {
        checkDesktopView();
      }
    }
    if (Object.keys(config).includes("instruction") && config["instruction"]) {
      checkDesktopView();
    }
  }, []);

  // don't fire the no-response warning after the page has moved on
  useEffect(() => () => clearTimeout(locationTimer.current), []);

  // hello

  return Object.keys(config).includes("directModule") && (clientId !== "arval_dev" && clientId !== "arval_prod") ? (
    config["directModule"] ? (
      <div className="result-wait">
        <img src={loading}></img>
        <h3>Verifying Token ...</h3>
      </div>
    ) : (
      <div
        id="screen2"
        className="screen"
        style={{
          height: screenHeight
            ? ["porto_seguros"].includes(clientId)
              ? "90dvh"
              : "100dvh"
            : "100lvh",
          width: "100vw",
          position: "relative",
          padding: "0%",
        }}
      >
        <div
          style={{ height: "60vh", padding: "10% 2%" }}
          className="scroll-container"
        >
          {moduleSelect && (
            <div className="permissionCss" style={{ flexDirection: "column" }}>
              <div className="permissionCss">
                <div className="permissionCssdiv">
                  <h4>
                    {Object.keys(config["errors"]).includes("gyroHeaderText")
                      ? config["errors"]["gyroHeaderText"]
                      : getTranslateText("Gyro Permission")}
                  </h4>
                  <p>
                    {Object.keys(config["errors"]).includes(
                      "gyroRequirementText"
                    )
                      ? config["errors"]["gyroRequirementText"]
                      : getTranslateText(
                        "For detecting phone position WRT car"
                      )}
                  </p>
                </div>
                <div className="permmisionbtndiv">
                  {gyroPermission === null ? (
                    <button
                      style={
                        config["colors"]["permissionBtn"]
                          ? {
                            background: config["colors"]["permissionBtn"],
                            color: "var(--btn-text, #fff)",
                          }
                          : { background: config["colors"]["btn"] }
                      }
                      onClick={() => checkGyroPermission()}
                    >
                      {Object.keys(config["errors"]).includes("alowBtnText")
                        ? config["errors"]["alowBtnText"]
                        : getTranslateText("Allow")}
                    </button>
                  ) : gyroPermission === true ? (
                    <img
                      src={allowedImg}
                      style={{ margin: "0px", width: "45px" }}
                    />
                  ) : gyroPermission === "loading" ? (
                    <img style={{ width: "36px" }} src={loadingGif} />
                  ) : (
                    <img
                      src={deniedImg}
                      style={{ margin: "0px", width: "36px" }}
                    />
                  )}
                </div>
              </div>
              <p ref={ackoLogs}></p>
              <div>
                <p
                  className="permissionWarningtext"
                  style={{
                    whiteSpace: "pre-wrap",
                    textAlign: "left",
                    marginTop: "15px",
                  }}
                >
                  {cameraWarning.map((e) => e.type === "gyro" && e.warning)}
                </p>
              </div>
            </div>
          )}
        </div>
        <div
          style={{
            height: "auto",
            position: "absolute",
            width: "96vw",
            bottom: "10px",
            padding: "0% 2%",
          }}
        >
          <div className="permissionWarning">
            <p
              className="permissionWarningtext"
              style={{ whiteSpace: "pre-wrap" }}
            >
              {cameraWarning.length === 0
                ? showAlert && showAlert
                : cameraWarning.map((e) => e.type === "desktop" && e.warning)}
            </p>
          </div>
          <div className="InstrBtn">
            {loading ? (
              <img
                style={{
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto",
                  width: "50px",
                  marginTop: "5px",
                }}
                src={loadingGif}
              ></img>
            ) : (
              <Button
                disabled={disabled}
                wide={true}
                onclick={() => {
                  if (permissionStep) {
                    if (disabled === false) switchLandscape();
                  }
                  checkDesktopView();
                  setSwitchBtn(0);
                }}
                text={config["instruction-page"]["btn-text"]}
              />
            )}
          </div>
        </div>
      </div>
    )
  ) : (
    <div
      id="screen2"
      className="screen"
      style={{
        height: screenHeight
          ? ["porto_seguros"].includes(clientId)
            ? "90dvh"
            : "100dvh"
          : "100lvh",
        width: "100vw",
        position: "relative",
        padding: "0%",
      }}
    >
      {["porto_seguros"].includes(clientId) ? <div></div> : <Navbar />}
      {/* Hidden once Continue is pressed: by then the flow is already on its
          way to the menu. */}
      {clientId === "liberty_dev" && !loading && (
        <button
          type="button"
          className="liberty-back-btn"
          aria-label={getTranslateText("Back")}
          style={{ zIndex: 2, color: inkOn(config["colors"]["nav"]) }}
          onClick={backBtn}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
        </button>
      )}
      <div
        style={["client_1514", "client_1514_uat"].includes(clientId) ? { height: "75vh", padding: "0% 2%" } : { height: "70vh", padding: "0% 2%" }}
        className="scroll-container"
      >
        {switchBtn ? (
          <img
            src={
              Object.keys(config["instruction-page"]).includes("image")
                ? config["instruction-page"]["image"]
                : config["intro-page"]["image"]
            }
            style={{ width: "100px" }}
          ></img>
        ) : (
          ""
        )}
        {permissionStep ? (
          <h1>
            {Object.keys(config["errors"]).includes("permissonHeaderText")
              ? config["errors"]["permissonHeaderText"]
              : getTranslateText("Please allow permissions")}
          </h1>
        ) : (
          <h1>{config["instruction-page"]["title"]}</h1>
        )}
        {permissionStep ? (
          <div style={{ marginTop: "10%" }}>
            {/* camera permission */}
            <div className="permissionCss" style={{ flexDirection: "column" }}>
              <div className="permissionCss">
                <div className="permissionCssdiv">
                  <h4>
                    {Object.keys(config["errors"]).includes("cameraHeaderText")
                      ? config["errors"]["cameraHeaderText"]
                      : getTranslateText("Camera Permission")}
                  </h4>
                  <p>
                    {Object.keys(config["errors"]).includes(
                      "cameraRequirementText"
                    )
                      ? config["errors"]["cameraRequirementText"]
                      : getTranslateText("For capturing photo / video of car")}
                  </p>
                </div>
                <div className="permmisionbtndiv">
                  {cameraPermission === null ? (
                    <button
                      style={
                        config["colors"]["permissionBtn"]
                          ? {
                            background: config["colors"]["permissionBtn"],
                            color: "var(--btn-text, #fff)",
                          }
                          : { background: config["colors"]["btn"] }
                      }
                      onClick={() => checkCameraPermission()}
                    >
                      {Object.keys(config["errors"]).includes("alowBtnText")
                        ? config["errors"]["alowBtnText"]
                        : getTranslateText("Allow")}
                    </button>
                  ) : cameraPermission === true ? (
                    <img
                      src={allowedImg}
                      style={{ margin: "0px", width: "45px" }}
                    />
                  ) : cameraPermission === "loading" ? (
                    <img style={{ width: "36px" }} src={loadingGif} />
                  ) : (
                    <img
                      src={deniedImg}
                      style={{ margin: "0px", width: "36px" }}
                    />
                  )}
                </div>
              </div>
              <div>
                <p
                  className="permissionWarningtext"
                  style={{
                    whiteSpace: "pre-wrap",
                    textAlign: "left",
                    // marginTop: "20px",
                  }}
                >
                  {cameraWarning.map((e) => e.type === "camera" && e.warning)}
                </p>
              </div>
            </div>
            {/* Gyro permission */}
            {moduleSelect && (
              <div
                className="permissionCss"
                style={{ flexDirection: "column" }}
              >
                <div className="permissionCss">
                  <div className="permissionCssdiv">
                    <h4>
                      {Object.keys(config["errors"]).includes("gyroHeaderText")
                        ? config["errors"]["gyroHeaderText"]
                        : getTranslateText("Gyro Permission")}
                    </h4>
                    <p>
                      {Object.keys(config["errors"]).includes(
                        "gyroRequirementText"
                      )
                        ? config["errors"]["gyroRequirementText"]
                        : getTranslateText(
                          "For detecting phone position WRT car"
                        )}
                    </p>
                  </div>
                  <div className="permmisionbtndiv">
                    {gyroPermission === null ? (
                      <button
                        style={
                          config["colors"]["permissionBtn"]
                            ? {
                              background: config["colors"]["permissionBtn"],
                              color: "var(--btn-text, #fff)",
                            }
                            : { background: config["colors"]["btn"] }
                        }
                        onClick={() => checkGyroPermission()}
                      >
                        {Object.keys(config["errors"]).includes("alowBtnText")
                          ? config["errors"]["alowBtnText"]
                          : getTranslateText("Allow")}
                      </button>
                    ) : gyroPermission === true ? (
                      <img
                        src={allowedImg}
                        style={{ margin: "0px", width: "45px" }}
                      />
                    ) : gyroPermission === "loading" ? (
                      <img style={{ width: "36px" }} src={loadingGif} />
                    ) : (
                      <img
                        src={deniedImg}
                        style={{ margin: "0px", width: "36px" }}
                      />
                    )}
                  </div>
                </div>
                <div>
                  <p
                    className="permissionWarningtext"
                    style={{
                      whiteSpace: "pre-wrap",
                      textAlign: "left",
                      marginTop: "15px",
                    }}
                  >
                    {cameraWarning.map((e) => e.type === "gyro" && e.warning)}
                  </p>
                </div>
              </div>
            )}
            {/* Location permission */}
            {!Object.keys(config).includes("hideLocationPermission") || !config["hideLocationPermission"] ?
              Object.keys(config).includes("loactionOptional") ? (
                config["loactionOptional"] ? (
                  <div
                    className="permissionCss"
                    style={{ flexDirection: "column" }}
                  >
                    <div className="permissionCss">
                      <div className="permissionCssdiv">
                        <h4>
                          {Object.keys(config["errors"]).includes(
                            "locationHeaderText"
                          )
                            ? config["errors"]["locationHeaderText"]
                            : getTranslateText("Location Permission")}{" "}
                          {Object.keys(config).includes(
                            "restrictionforLocationPermission"
                          ) ? (
                            !config["restrictionforLocationPermission"] &&
                              Object.keys(config["errors"]).includes(
                                "locationHeaderOptionalText"
                              ) ? (
                              ""
                            ) : (
                              ""
                            )
                          ) : Object.keys(config["errors"]).includes(
                            "locationHeaderOptionalText"
                          ) ? (
                            config["errors"]["locationHeaderOptionalText"]
                          ) : (
                            <span dir="ltr">
                              {getTranslateText("(Optional)")}
                            </span>
                          )}
                        </h4>
                        <p>
                          {Object.keys(config["errors"]).includes(
                            "locationRequirementText"
                          )
                            ? config["errors"]["locationRequirementText"]
                            : getTranslateText(
                              "To know the location of your inspection"
                            )}
                        </p>
                      </div>
                      <div className="permmisionbtndiv">
                        {locationPermission === null ? (
                          <button
                            style={
                              config["colors"]["permissionBtn"]
                                ? {
                                  background: config["colors"]["permissionBtn"],
                                  color: "var(--btn-text, #fff)",
                                }
                                : { background: config["colors"]["btn"] }
                            }
                            onClick={() => CheckLocationPermission()}
                          >
                            {Object.keys(config["errors"]).includes("alowBtnText")
                              ? config["errors"]["alowBtnText"]
                              : getTranslateText("Allow")}
                          </button>
                        ) : locationPermission === true ? (
                          <img
                            src={allowedImg}
                            style={{ margin: "0px", width: "45px" }}
                          />
                        ) : locationPermission === "loading" ? (
                          <img style={{ width: "36px" }} src={loadingGif} />
                        ) : (
                          <img
                            src={deniedImg}
                            style={{ margin: "0px", width: "36px" }}
                          />
                        )}
                      </div>
                    </div>
                    <div>
                      <p
                        className="permissionWarningtext"
                        style={{
                          whiteSpace: "pre-wrap",
                          textAlign: "left",
                          marginTop: "15px",
                        }}
                      >
                        {cameraWarning.map(
                          (e) => e.type === "loaction" && e.warning
                        )}
                      </p>
                    </div>
                  </div>
                ) : (
                  <></>
                )
              ) : (
                <div
                  className="permissionCss"
                  style={{ flexDirection: "column" }}
                >
                  <div className="permissionCss">
                    <div className="permissionCssdiv">
                      {clientId === "autogroup" ? (
                        <h4>
                          {Object.keys(config).includes(
                            "restrictionforLocationPermission"
                          ) ? (
                            !config["restrictionforLocationPermission"] &&
                              Object.keys(config["errors"]).includes(
                                "locationHeaderOptionalText"
                              ) ? (
                              ""
                            ) : (
                              ""
                            )
                          ) : Object.keys(config["errors"]).includes(
                            "locationHeaderOptionalText"
                          ) ? (
                            config["errors"]["locationHeaderOptionalText"]
                          ) : (
                            <span dir="ltr">
                              {getTranslateText("(Optional)")}
                            </span>
                          )}
                          {Object.keys(config["errors"]).includes(
                            "locationHeaderText"
                          )
                            ? config["errors"]["locationHeaderText"]
                            : getTranslateText("Location Permission")}{" "}
                        </h4>
                      ) : (
                        <h4>
                          {Object.keys(config["errors"]).includes(
                            "locationHeaderText"
                          )
                            ? config["errors"]["locationHeaderText"]
                            : getTranslateText("Location Permission")}{" "}
                          {Object.keys(config).includes(
                            "restrictionforLocationPermission"
                          ) ? (
                            !config["restrictionforLocationPermission"] &&
                              Object.keys(config["errors"]).includes(
                                "locationHeaderOptionalText"
                              ) ? (
                              ""
                            ) : (
                              ""
                            )
                          ) : Object.keys(config["errors"]).includes(
                            "locationHeaderOptionalText"
                          ) ? (
                            config["errors"]["locationHeaderOptionalText"]
                          ) : (
                            <span dir="ltr">
                              {getTranslateText("(Optional)")}
                            </span>
                          )}
                        </h4>
                      )}
                      <p>
                        {Object.keys(config["errors"]).includes(
                          "locationRequirementText"
                        )
                          ? config["errors"]["locationRequirementText"]
                          : getTranslateText(
                            "To know the location of your inspection"
                          )}
                      </p>
                    </div>
                    <div className="permmisionbtndiv">
                      {locationPermission === null ? (
                        <button
                          style={
                            config["colors"]["permissionBtn"]
                              ? {
                                background: config["colors"]["permissionBtn"],
                                color: "var(--btn-text, #fff)",
                              }
                              : { background: config["colors"]["btn"] }
                          }
                          onClick={() => CheckLocationPermission()}
                        >
                          {Object.keys(config["errors"]).includes("alowBtnText")
                            ? config["errors"]["alowBtnText"]
                            : getTranslateText("Allow")}
                        </button>
                      ) : locationPermission === true ? (
                        <img
                          src={allowedImg}
                          style={{ margin: "0px", width: "45px" }}
                        />
                      ) : locationPermission === "loading" ? (
                        <img style={{ width: "36px" }} src={loadingGif} />
                      ) : (
                        <img
                          src={deniedImg}
                          style={{ margin: "0px", width: "36px" }}
                        />
                      )}
                    </div>
                  </div>
                  <div>
                    <p
                      className="permissionWarningtext"
                      style={{
                        whiteSpace: "pre-wrap",
                        textAlign: "left",
                        marginTop: "15px",
                      }}
                    >
                      {cameraWarning.map(
                        (e) => e.type === "loaction" && e.warning
                      )}
                    </p>
                  </div>
                </div>
              ) : ""}
          </div>
        ) : (
          <div>
            {config["instruction-page"]["instructions"].map(
              (element, index) => {
                return (
                  <div className="screen2-rules" key={index}>
                    <div>{index + 1}</div>
                    {/* {renderInstructionText(element)} */}
                    {element.startsWith("**") && element.endsWith("**") ? (
                      <p><b style={{ fontFamily: "sans-serif", fontWeight: "900", color: "var(--app-text, #000000)" }}>{element.replace(/\*\*/g, "")}</b></p>
                    ) : (
                      <p>{element}</p>
                    )}
                  </div>
                );
              }
            )}
          </div>
        )}
      </div>
      <div
        style={{
          height: "auto",
          position: "absolute",
          width: "96vw",
          bottom: "10px",
          padding: "0% 2%",
        }}
      >
        <div className="permissionWarning" style={["client_1514", "client_1514_uat"].includes(clientId) ? { marginBottom: "0px" } : {}}>
          <p
            className="permissionWarningtext"
            style={["client_1514", "client_1514_uat"].includes(clientId) ? { whiteSpace: "pre-wrap", padding: "0px" } : { whiteSpace: "pre-wrap" }}
          >
            {cameraWarning.length === 0
              ? showAlert && showAlert
              : cameraWarning.map((e) => e.type === "desktop" && e.warning)}
          </p>
        </div>
        <div className="InstrBtn">
          {loading ? (
            <img
              style={{
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                width: "50px",
                marginTop: "5px",
              }}
              src={loadingGif}
            ></img>
          ) : (
            <Button
              disabled={disabled}
              wide={true}
              onclick={() => {
                if (permissionStep) {
                  if (disabled === false) switchLandscape();
                }
                if (
                  Object.keys(config).includes("leavePermission") &&
                  config["leavePermission"]
                ) {
                  switchLandscape();
                } else checkDesktopView();
                setSwitchBtn(0);
              }}
              text={config["instruction-page"]["btn-text"]}
            />
          )}
        </div>
      </div>
      {clientId === "client_1257_uat" && (
        <JarvisTracking
          URL="https://sit-r2-account.tatadigital.com/v2/tdl-sso-auth.js"
          clientId="INSPEKTLABS-WEB-APP"
          customerHash={caseId}
        />
      )}
      {clientId === "client_1257" && (
        <JarvisTracking
          URL="https://accounts.tatadigital.com/v2/tdl-sso-auth.js"
          clientId="INSPEKTLABS-WEB-APP"
          customerHash={caseId}
        />
      )}
    </div>
  );
};

export default Instructions;
